import { Typography } from '@euler/app/components/typography';
import { CommonTaskStatus } from '@euler/model/enum';
import { Maybe } from '@euler/types';
import { memo } from 'react';
import { View } from 'react-native';
import { useBoardUnit } from '../../functions/useBoardUnit';
import { workshopBoardColors as colors } from '../../workshopBoardColors';

export type BoardStageKind = 'preInspection' | 'inspection' | 'construction';

// Worded as the status badge's (`StatusBadge`).
const kStageText: Record<BoardStageKind, [string, string, string]> = {
  preInspection: ['待预检', '预检中', '已预检'],
  inspection: ['待检测', '检测中', '已检测'],
  construction: ['待施工', '施工中', '已施工'],
};

const kStageColor: Record<CommonTaskStatus, string> = {
  [CommonTaskStatus.Pending]: colors.faint,
  [CommonTaskStatus.InProgress]: colors.active,
  [CommonTaskStatus.Finished]: colors.done,
};

/** A stage of the task: a dot in its color and its word; none yet, `—`. */
export const StageCell = memo(
  ({
    kind,
    status,
    flex,
  }: {
    kind: BoardStageKind;
    status: Maybe<CommonTaskStatus>;
    flex: number;
  }) => {
    const u = useBoardUnit();
    const started = status != null;
    const color = started ? kStageColor[status] : colors.faint;
    return (
      <View
        style={{ flex, flexDirection: 'row', alignItems: 'center', gap: u(10) }}
      >
        {started ? (
          <View
            style={{
              width: u(14),
              height: u(14),
              borderRadius: u(7),
              backgroundColor: color,
            }}
          />
        ) : null}
        <Typography.Text
          size={u(26)}
          color={status === CommonTaskStatus.Pending ? colors.muted : color}
          numberOfLines={1}
        >
          {started ? kStageText[kind][status] : '—'}
        </Typography.Text>
      </View>
    );
  },
);
